import api from "./client";

export type CommsChannel = "whatsapp" | "email";
export type CommsDirection = "inbound" | "outbound";

export interface CommsJournalItem {
  id: string;
  source: "communications_log" | "emails_sent";
  channel: CommsChannel;
  direction: CommsDirection;
  discussion_id?: string | null;
  client_id?: string | null;
  peer?: string | null;
  peers?: string[];
  subject?: string | null;
  body?: string | null;
  provider_msg_id?: string | null;
  status?: string | null;
  created_at?: string | null;
}

export interface CommsJournalParams {
  org_id?: string;
  channel?: CommsChannel;
  direction?: CommsDirection;
  status?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

export interface CommsOrg {
  id: string;
  name: string;
}

export const communicationsJournalApi = {
  /** Super-admin merged journal of all client WhatsApp + email (in & out). */
  list: async (
    params?: CommsJournalParams,
  ): Promise<{ items: CommsJournalItem[]; total: number }> => {
    const resp = await api.get("/communications/journal", { params });
    return {
      items: resp.data,
      total: parseInt(resp.headers["x-total-count"] || "0", 10),
    };
  },

  /** Orgs a super-admin can pick from (id + name). */
  listOrgs: async (): Promise<CommsOrg[]> => {
    const { data } = await api.get("/communications/orgs");
    return data;
  },
};
